module.exports = __webpack_public_path__ + "img/Thank you.e2b5f029.png";